const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path
            d="M25.648 0c14.164 0 25.647 11.505 25.647 25.698 0 14.192-11.483 25.698-25.647 25.698C11.483 51.396 0 39.89 0 25.698 0 11.505 11.483 0 25.648 0zm0 36.21a2.334 2.334 0 00-2.332 2.337 2.334 2.334 0 002.332 2.336 2.334 2.334 0 002.331-2.336 2.334 2.334 0 00-2.331-2.336zm1.615-24.374c-5.12-.983-9.776 2.855-9.776 7.94a1.75 1.75 0 001.749 1.752 1.75 1.75 0 001.748-1.753c0-2.88 2.654-5.067 5.62-4.498 1.803.347 3.267 1.795 3.615 3.564a4.584 4.584 0 01-2.708 5.144c-2.213.95-3.612 3.186-3.612 5.618v1.351a1.75 1.75 0 001.749 1.752 1.75 1.75 0 001.749-1.752v-1.35c0-1.062.595-2.013 1.493-2.399a8.088 8.088 0 004.76-9.04c-.623-3.176-3.189-5.714-6.387-6.33z"
            id="question-fill__a" />
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <g transform="translate(2 2)">
            <mask id="question-fill__b" fill="#fff">
                <use xlink:href="#question-fill__a" />
            </mask>
            <use fill="currentColor" fill-rule="nonzero" xlink:href="#question-fill__a" />
            <path fill="currentColor" mask="url(#question-fill__b)" d="M-2.332-2.336h55.958v56.068H-2.332z" />
        </g>
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=question-fill.es.3Nwutzmn.js.map
